import React from 'react';
import styles from '../styles/header.module.css';

const Header = ({ title }) => {
    return (
        <header className={styles.header}>
            <div className={styles.headerLeft}>
                <h1 className={styles.title}>{title}</h1>
            </div>

        </header>
    );
};

export default Header;
